import styles from './PoliticaDetails.module.css'

export default function PoliticaDetails(){
    return(
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <h1>Política de Privacidade</h1>
                    <p className={styles.data}>Última atualização: 05/01/2025</p>
                    <p>
                        A <b className={styles.negrito}>DevZone Innovations </b>
                        valoriza a sua privacidade e está comprometida em proteger os 
                        dados pessoais de seus usuários. Esta Política de Privacidade 
                        explica como coletamos, usamos, armazenamos e protegemos suas 
                        informações.
                    </p>
                </div>
                <h2>1. Coleta de Informações</h2>
                <p className={styles.text}>
                    Coletamos informações pessoais que você nos fornece voluntariamente, 
                    como nome, e-mail, telefone e mensagens enviadas por formulários de 
                    contato. Também coletamos automaticamente informações de navegação, 
                    como endereço IP, tipo de navegador, páginas visitadas e tempo de 
                    permanência no site, por meio de cookies e tecnologias similares.
                </p>

                <h2>2. Uso das Informações</h2>
                <p className={styles.text}>
                    As informações coletadas são utilizadas para:
                </p>
                <ul>
                    <li>
                        Melhorar sua experiência em nosso site e serviços.
                    </li>
                    <li>
                        Responder suas solicitações e dúvidas.
                    </li>
                </ul>

                <h2>3. Compartilhamento das Informações</h2>
                <p className={styles.text}>
                    Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros, exceto:
                </p>
                <ul>
                    <li>
                        Com parceiros e fornecedores que auxiliam na operação do site e serviços, sob obrigação de confidencialidade.
                    </li>
                    <li>
                        Quando exigido por lei ou autoridades competentes.
                    </li>
                </ul>

                <h2>4. Direito dos Usuários</h2>
                <p className={styles.text}>
                    Você pode solicitar acesso, correção ou exclusão de seus 
                    dados pessoais a qualquer momento. Para isso, entre em 
                    contato conosco pelo e-mail 
                    <a href='mailto:devzoneinnovations@gmail.com'> devzoneinnovations@gmail.com</a>.
                </p>

                <h2>5. Cookies</h2>
                <p className={styles.text}>
                    Utilizamos cookies para melhorar a funcionalidade do site e 
                    oferecer uma melhor experiência de navegação. Você pode 
                    gerenciar ou desativar os cookies nas configurações do 
                    seu navegador.
                </p>

                <h2>6. Alterações nesta Política</h2>
                <p className={styles.text}>
                    Podemos atualizar esta Política de Privacidade periodicamente. 
                    Recomendamos que você a revise regularmente para se 
                    manter informado.
                </p>

                <h2>7. Contato</h2>
                <p className={styles.text}>
                    Em caso de dúvidas sobre esta Política de Privacidade, entre em contato conosco:
                </p>
                <ul>
                    <li>
                        <a 
                            href='mailto:devzoneinnovations@gmail.com'> 
                            devzoneinnovations@gmail.com
                        </a>
                    </li>
                    <li>
                        <a 
                            href='https://wa.me/5511912125307'> 
                            +55 (11) 998505-0470
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}